interface TabItemProps {
  value: string;
  label: string;
  activeValue?: string;
  onClick?: (tabValue: string) => void;
  textColor?: string;
  indicatorColor?: string;
  fontSize?: number;
}

export function TabItem({ label, value, activeValue, onClick, textColor, indicatorColor, fontSize }: TabItemProps) {
  return (
    <div
      className={`relative flex flex-col items-center justify-center cursor-pointer py-2
      `}
      onClick={() => onClick && onClick(value)}
    >
      <h3
        style={{ fontSize }}
        className={`text-base whitespace-nowrap ${
          activeValue === value ? `font-semibold` : 'font-normal'
        } ${textColor}`}
      >
        {label}
      </h3>
      {activeValue === value && <div className={`absolute bottom-0 ${indicatorColor} w-4/5 h-1 rounded-t-md`}></div>}
    </div>
  );
}
